'use client';

import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';

import { Box, Button, IconButton, Modal, Typography } from '@mui/material';

import { OTPSchema } from 'src/utils/validations';

import { Form, Field } from 'src/components/hook-form';

import { useLocale } from 'src/locales';
import { useDeleteUserAccountConfirmation } from 'src/api/user-delete/useDeleteUser';
import { CloseIcon } from 'src/theme/core/components/mui-x-data-grid';
import { notify } from 'src/utils/helper';

export function UserDeleteOTPModal({ open, mobileNumber, onClose }) {
  const { t } = useLocale();

  const defaultValues = {
    otp: '',
  };

  const {
    data: deletedUserConfirmData,
    mutateAsync: confirmDelete,
    isPending,
  } = useDeleteUserAccountConfirmation();

  const methods = useForm({
    resolver: zodResolver(OTPSchema),
    defaultValues,
    mode: 'all',
  });

  const {
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { isSubmitting, isValid },
  } = methods;

  useEffect(() => {
    if (open) {
      reset();
    }
  }, [open, reset]);

  useEffect(() => {
    if (deletedUserConfirmData?.success) {
      notify('success', deletedUserConfirmData?.success || t('User_Deleted_Successfully'));
      onClose?.();
    }
    if (deletedUserConfirmData?.error) {
      notify(
        'error',
        deletedUserConfirmData?.message ||
          deletedUserConfirmData?.error ||
          t('Something_Went_Wrong')
      );
    }
  }, [deletedUserConfirmData]);

  const onSubmit = handleSubmit(async (data) => {
    confirmDelete({
      otp: data?.otp || '',
      mobileNumber: mobileNumber || '',
    });
  });

  // const handleResendOTP = () => {
  //   methods.reset();
  //   resendOTP({ mobileNumber, userID });
  // };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styles.modal}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h6">{t('OTP_has_been_send_to')}</Typography>
          <IconButton onClick={onClose} aria-label="close modal">
            <CloseIcon />
          </IconButton>
        </Box>
        <Form methods={methods} onSubmit={onSubmit}>
          <Box sx={{ my: 2 }}>
            <Typography sx={{ textAlign: 'center' }}>
              {t('OTP_has_been_send_to')} {mobileNumber}
            </Typography>
            <Box sx={{ textAlign: 'center', my: 3 }}></Box>
            <Field.Text
              required
              name="otp"
              label={t('Enter_OTP')}
              inputStyle={{ fontWeight: '900', letterSpacing: 20, fontSize: 16 }}
              maxLength={4}
            />
            <Button
              fullWidth
              color="primary"
              size="large"
              type="submit"
              variant="contained"
              loading={isPending}
              disabled={isSubmitting}
              sx={{
                '& .MuiCircularProgress-root': {
                  color: '#0d9d57', // change loader colour here
                  width: '20px !important',
                  height: '20px !important',
                },
                my: 3,
              }}
            >
              {t('Delete_Account')}
            </Button>
            {/* <Typography variant="body2" sx={{ textAlign: 'center' }}>
          {t('Did_not_received')} ? ?{' '}
          <Typography
            component="span"
            role="button"
            onClick={handleResendOTP}
            sx={{ color: '#0d9d57', cursor: 'pointer' }}
          >
            {t('Resend_OTP')}
          </Typography>
        </Typography> */}
          </Box>
        </Form>
      </Box>
    </Modal>
  );
}

const styles = {
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', md: '30%' },
    // height: '90%',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 2,
  },
  keyValueContainer: { display: 'flex', gap: 2, width: '100%', justifyContent: 'space-between' },
  key: { color: 'text.secondary' },
  value: { typography: 'subtitle2', textAlign: 'right' },
};
